"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aggregateSalesPackages = exports.aggregateStandardEquipment = exports.aggregateAccessories = exports.aggregateTireSets = exports.aggregateVarnishes = exports.buildVariantImagesFromSizes = exports.DefaultImageUrl = void 0;
const enums_1 = require("../../../../enums");
const crystallize_pim_1 = require("./crystallize-pim");
var DefaultImageUrl;
(function (DefaultImageUrl) {
    DefaultImageUrl["SUMMER_TIRE_SET"] = "https://media.crystallize.com/bos-qa/20/8/10/3/tire-set.png";
    DefaultImageUrl["WINTER_TIRE_SET"] = "https://media.crystallize.com/bos-qa/20/8/10/3/winter-tire-set.png";
    DefaultImageUrl["ACCESSORY"] = "https://media.crystallize.com/bos-qa/20/9/2/1/fragilebox.png";
    DefaultImageUrl["VEHICLE"] = "https://media.crystallize.com/bos-qa/20/9/2/2/coveredcar.png";
})(DefaultImageUrl = exports.DefaultImageUrl || (exports.DefaultImageUrl = {}));
const buildVariantImagesFromSizes = (url, sizes = [100, 500]) => {
    return [
        {
            url,
            variants: sizes.map((size) => {
                const arr = url.split('/');
                return {
                    url: arr.slice(0, arr.length - 1).join('/') + `/@${size}/` + arr[arr.length - 1],
                    width: size,
                };
            }),
        },
    ];
};
exports.buildVariantImagesFromSizes = buildVariantImagesFromSizes;
const aggregateVarnishes = (data) => {
    /**
     * Allows multiple pricings and recommendations for the same varnish object
     */
    if (!data ||
        !data.model ||
        !data.model.modelSeries ||
        !data.model.modelSeries.varnishes ||
        (!data.model.modelSeries.cosmeticPricing && !data.model.modelSeries.cosmeticRecommendations)) {
        return [];
    }
    const series = data.model.modelSeries;
    const varnishPricing = Array.isArray(series.cosmeticPricing)
        ? series.cosmeticPricing.find((table) => table.title == enums_1.CosmeticSectionTitles.VARNISHES)
        : null;
    const varnishRecommendations = Array.isArray(series.cosmeticRecommendations)
        ? series.cosmeticRecommendations.find((table) => table.title == enums_1.CosmeticSectionTitles.VARNISHES)
        : null;
    return series.varnishes
        .filter((varnish) => {
        const compatibility = varnish.compatibility
            ? varnish.compatibility.properties.find((property) => property.key === series.name)
            : null;
        if (!compatibility || !compatibility.value) {
            return true;
        }
        const compatibleConfigurations = compatibility.value.split(',').map((x) => x.trim());
        return compatibleConfigurations.includes(data.sku);
    })
        .map((varnish) => {
        if (!varnish) {
            return null;
        }
        const getAdditionalPrice = () => {
            const priceEntry = varnishPricing && varnishPricing.properties
                ? varnishPricing.properties.find((price) => price.key === varnish.varnishCode)
                : null;
            if (priceEntry && priceEntry.value) {
                const priceData = priceEntry.value.split('/') || [];
                return priceData.map((item) => (item ? parseFloat(item) : null));
            }
        };
        const getIsRecommended = () => {
            return varnishRecommendations && varnishRecommendations.properties
                ? Boolean(varnishRecommendations.properties.find((recommendation) => recommendation.key === varnish.varnishCode))
                : false;
        };
        const [additionalPrice, additionalPriceExcludingVat, vat] = getAdditionalPrice();
        const hexCode = varnish.hexCode;
        const id = varnish === null || varnish === void 0 ? void 0 : varnish.id;
        const isRecommended = getIsRecommended();
        const name = varnish.name;
        const type = varnish.type;
        const varnishCode = varnish.varnishCode;
        const retailerMargin = 0; // TODO denne må oppdateres med PIM 2.0
        return {
            additionalPrice,
            additionalPriceExcludingVat,
            hexCode,
            id,
            isRecommended,
            name,
            type,
            varnishCode,
            vat,
            retailerMargin: retailerMargin,
        };
    });
};
exports.aggregateVarnishes = aggregateVarnishes;
const aggregateTireSets = (data) => {
    /**
     * Allows multiple pricings and recommendations for the same tireSet object
     */
    if (!data || !data.tires || (!data.cosmeticPricing && !data.cosmeticRecommendations)) {
        return [];
    }
    const tireSetPricing = Array.isArray(data.cosmeticPricing)
        ? data.cosmeticPricing.find((table) => table.title == enums_1.CosmeticSectionTitles.TIRES)
        : null;
    const tireSetRecommendations = Array.isArray(data.cosmeticRecommendations)
        ? data.cosmeticRecommendations.find((table) => table.title == enums_1.CosmeticSectionTitles.TIRES)
        : null;
    return data.tires.map((tireSet) => {
        if (!tireSet) {
            return null;
        }
        const getAdditionalPrice = () => {
            const priceEntry = tireSetPricing && tireSetPricing.properties
                ? tireSetPricing.properties.find((price) => price.key === tireSet.nowaCode)
                : null;
            if (priceEntry && priceEntry.value) {
                const priceData = priceEntry.value.split('/') || [];
                return priceData.map((item) => (item ? parseFloat(item) : null));
            }
        };
        const getIsRecommended = () => {
            return tireSetRecommendations && tireSetRecommendations.properties
                ? Boolean(tireSetRecommendations.properties.find((recommendation) => recommendation.key === tireSet.nowaCode))
                : false;
        };
        const [additionalPrice, additionalPriceExcludingVat, vat, retailPrice, retailerMargin] = getAdditionalPrice();
        const id = tireSet === null || tireSet === void 0 ? void 0 : tireSet.id;
        const name = tireSet.name;
        const isRecommended = getIsRecommended();
        const images = (0, crystallize_pim_1.mapImages)(tireSet.images);
        const rimManufacturer = tireSet.rimManufacturer;
        const tireManufacturer = tireSet.tireManufacturer;
        const nobos = tireSet.nowaCode;
        const type = null;
        const description = tireSet.description;
        const spikes = tireSet.spikes;
        const winterWheel = tireSet.winterWheel;
        return {
            additionalPrice,
            additionalPriceExcludingVat,
            retailPrice,
            retailerMargin,
            id,
            name,
            images: images.length > 0 ? images : (0, exports.buildVariantImagesFromSizes)(DefaultImageUrl.WINTER_TIRE_SET),
            rimManufacturer,
            tireManufacturer,
            nobos,
            type,
            description,
            isRecommended,
            spikes,
            winterWheel,
            vat,
        };
    });
};
exports.aggregateTireSets = aggregateTireSets;
// TODO: Implement later based on `aggregateVarnishes`
const aggregateInteriors = (data) => {
    return;
};
const aggregateAccessories = (data) => {
    /**
     * Allows multiple pricings and recommendations for the same accessory object
     */
    if (!data ||
        !data.modelSeries ||
        !data.modelSeries.accessories ||
        (!data.modelSeries.cosmeticPricing && !data.modelSeries.cosmeticRecommendations)) {
        return [];
    }
    const series = data.modelSeries;
    const accessoryPricing = Array.isArray(series.cosmeticPricing)
        ? series.cosmeticPricing.find((table) => table.title == enums_1.CosmeticSectionTitles.ACCESSORIES)
        : null;
    const accessoryRecommendations = Array.isArray(series.cosmeticRecommendations)
        ? series.cosmeticRecommendations.find((table) => table.title == enums_1.CosmeticSectionTitles.ACCESSORIES)
        : null;
    return series.accessories
        .filter((accessory) => {
        const compatibility = accessory.modelCompatibility.properties.find((property) => property.key === series.name);
        const compatibleModels = compatibility ? compatibility.value : null;
        return ['all', data.name].includes(compatibleModels);
    })
        .map((accessory) => {
        if (!accessory) {
            return null;
        }
        const getAdditionalPrice = () => {
            const priceEntry = accessoryPricing && accessoryPricing.properties
                ? accessoryPricing.properties.find((price) => price.key === accessory.articleNumber)
                : null;
            if (priceEntry && priceEntry.value) {
                const priceData = priceEntry.value.split('/') || [];
                return priceData.map((item) => (item ? parseFloat(item) : null));
            }
        };
        const getIsRecommended = () => {
            return accessoryRecommendations && accessoryRecommendations.properties
                ? Boolean(accessoryRecommendations.properties.find((recommendation) => recommendation.key === accessory.articleNumber))
                : false;
        };
        const [price, priceExcludingVat, vat] = getAdditionalPrice();
        const customerPrice = null;
        const description = accessory.description;
        const id = accessory === null || accessory === void 0 ? void 0 : accessory.id;
        const images = (0, crystallize_pim_1.mapImages)(accessory.images);
        const isRecommended = getIsRecommended();
        const manufacturer = null;
        const margin = accessory.retailerMargin;
        const name = accessory.articleName;
        const retailPrice = accessory.retailPrice;
        const sku = accessory.articleNumber;
        const assemblyHours = accessory.assemblyHours;
        const assemblyPrice = accessory.assemblyPrice;
        const assemblyPriceExcludingVat = accessory.assemblyPriceExcludingVat;
        const marginExcludingVat = accessory.retailerMarginExcludingVat;
        const retailPriceExcludingVat = accessory.retailPriceExcludingVat;
        return {
            customerPrice,
            description,
            id,
            images: images.length > 0 ? images : (0, exports.buildVariantImagesFromSizes)(DefaultImageUrl.ACCESSORY),
            isRecommended,
            manufacturer,
            margin,
            name,
            price,
            priceExcludingVat,
            retailPrice,
            sku,
            assemblyHours,
            assemblyPrice,
            assemblyPriceExcludingVat,
            marginExcludingVat,
            retailPriceExcludingVat,
            vat,
        };
    });
};
exports.aggregateAccessories = aggregateAccessories;
const aggregateStandardEquipment = (data) => {
    if (!data || !Array.isArray(data)) {
        return [];
    }
    return [
        {
            name: 'Standardutstyr',
            equipment: data,
        },
    ];
};
exports.aggregateStandardEquipment = aggregateStandardEquipment;
const aggregateSalesPackages = (data) => {
    if (!data || !Array.isArray(data.salesPackages)) {
        return [];
    }
    return data.salesPackages.map((salesPackage) => {
        const additionalPrice = salesPackage.additionalPrice;
        const id = salesPackage === null || salesPackage === void 0 ? void 0 : salesPackage.id;
        const name = salesPackage.name;
        const paragraphContent = Array.isArray(salesPackage.equipment)
            ? salesPackage.equipment.find((paragraph) => paragraph.title.text.toLowerCase() == data.sku.toLowerCase())
            : null;
        const equipment = paragraphContent && Array.isArray(paragraphContent.body.plainText) ? paragraphContent.body.plainText : [];
        return {
            additionalPrice,
            equipment,
            id,
            name,
        };
    });
};
exports.aggregateSalesPackages = aggregateSalesPackages;
//# sourceMappingURL=aggregators.js.map